import { render, staticRenderFns } from "./Getrak.vue?vue&type=template&id=54fbc294&scoped=true"
import script from "./Getrak.vue?vue&type=script&lang=js"
export * from "./Getrak.vue?vue&type=script&lang=js"
import style0 from "./Getrak.vue?vue&type=style&index=0&id=54fbc294&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54fbc294",
  null
  
)

export default component.exports